export default "__VITE_ASSET__DB_Mm6X5__"